<template>
    <div class="drawer">
        <div class="drawer-type"><div class="drawer-title left">{{ lang['general.problems'] }}</div></div>
        <div class="drawer-contents">
            <div v-for="(problem, index) in problems" class="problem-card" :class="setActive(index)" @click="openProblem(problem, index + 1, 7)">
                <div class="prefix mr-1">{{ index + 1 }}. </div>
                <div class="problem-text" v-html="$options.filters.stripAndTruncate(problem.question, 60, '')">PROBLEM</div>
                <div class="problem-markers">
                    <i class="fas fa-bookmark mr-3" :class="{ flagged: problem.flagged }"></i>
                    <i class="fa-square" :class="[problem.complete ? 'fas' : 'far']"></i>
                </div>
            </div>
        </div>
        <div class="button-footer">
            <!-- <button v-if="assignment.feedback == 0" class="btn btn-primary btn-block" @click="submit">Submit</button> -->
            <button type="button" class="btn btn-primary btn-block" @click="exit(false)">{{ lang['button.save_and_exit'] }}</button>
            <button v-if="directsubmit == true" class="btn btn-success btn-block" @click="submit">Submit to LMS</button>
        </div>

        <problem-modal v-if="showModal" :type="modalType" :decisionIndex="decisionIndex" :decisionId="nID" :message="debugMessage"  @close="closeModal" @submit="exit(true)"></problem-modal>
    </div>
</template>

<script>
export default {
    props:['course', 'directsubmit'],
    data() {
        return {
            assignment: [],
            assignment_data: [],
            problems: [],
            selectedIndex: 0,
            lang: lang,
            showModal: false,
            modalType: '',
            decisionIndex: 0,
            nID: 0,
            debugMessage: '',
        }
    },

    mounted() {
        this.assignment = dbSets;
        let order = dbSets.problem_ids;
        for(let q = 0; q < order.length; q++) {
            if (dbQuestions[order[q]]) {
                if (!dbQuestions[order[q]].flagged) {
                    dbQuestions[order[q]].flagged = false;
                }
                if (dbProfiles[dbQuestions[order[q]].path_id] && !dbProfiles[dbQuestions[order[q]].path_id].invalid) {
                    this.problems.push(dbQuestions[order[q]]);
                }
            }
        }
        this.selectedIndex = 1;
        this.loadAssignment(this.problems[0]);
        bus.$on('traverseProblems', this.traverseProblems);
        bus.$on('markComplete', this.markQuestionComplete);
        bus.$on('showIncorrect', this.openModal);
        bus.$on('submit', this.exit);
        bus.$on('ltisuccess', this.ltisuccess);
        bus.$on('ltifail', this.ltifail);
        bus.$on('ltidebug', this.ltidebug);
        bus.$on('savesuccess', this.savesuccess);
        bus.$on('exittocourse', this.exittocourse);
    },

    methods: {
        loadAssignment(problem) {
            currentAssignmentID = this.assignment.id;
            currentQID = problem.id;
            switchToMode("path");
            buildAssignmentObj(this.assignment);
            this.openProblem(problem, 1);
        },

        markQuestionComplete(id, complete) {
            this.problems.forEach(problem => {
                if(problem.id == id) {
                    problem.complete = complete;
                }
            });
            this.$forceUpdate(); //fixes bug where list wasn't updating properly
            submitAssignment(false, true);
            if(feedbackLevel != 0) {
                this.openModal('complete');
            }
        },

        openProblem(problem, index) {
            if(currentPath.length > 0) {
                saveProblemProgress()
            }
            currentQID = problem.id
            this.selectedIndex = index;
            problem.index = index;
            this.$nextTick(function() {
                bus.$emit('viewProblem', problem);
            });
            showProblem();
        },

        openModal(type, nID = 0, index = 0) {
            this.modalType = type;
            this.decisionIndex = index;
            this.nID = nID;
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
        },

        traverseProblems(direction) {
            if(direction == 1 && (this.selectedIndex < this.problems.length)) {
                const nextProblem = this.problems[this.selectedIndex];
                this.selectedIndex = ++this.selectedIndex;
                this.openProblem(nextProblem, this.selectedIndex);
            } else if(direction == -1 && this.selectedIndex !=1) {
                const nextProblem = this.problems[this.selectedIndex - 2];
                this.selectedIndex = --this.selectedIndex;
                this.openProblem(nextProblem, this.selectedIndex);
            }
        },

        setActive(index) {
            return this.selectedIndex == index + 1 ? 'selected' : '';
        },

        submit() {
            this.openModal('confirm');
        },

        ltisuccess() {
            this.openModal('ltisuccess');
        },

        ltifail() {
            this.openModal('ltifail');
        },

        ltidebug(message) {
            this.debugMessage = message;
            this.openModal('debug');
        },

        savesuccess() {
            this.openModal('savesuccess');
        },

        exittocourse(){
            window.location.href = '/course-index/' + this.course;
        },

        async exit(submit = false) {
            $("#ltisubmit").attr("disabled", "disabled").html("Please wait...");
            //$("#lticancel").attr("disabled", "disabled").remove();
            await submitAssignment(submit, false);
        }
    }
}
</script>
